import Link from './Link';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'Link',
  ClassComponent: Link
});